import type { LucideIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/components/ui/utils";

interface SectionHeaderActionProps {
  className?: string;
  icon: LucideIcon;
  /** Drives both the accessible name and the tooltip, so they cannot drift. */
  label: string;
  onClick: () => void;
}

/**
 * Ghost icon button used for the trailing action of a section or dialog
 * header, with a tooltip and a 44px mobile or coarse-pointer touch target.
 */
export function SectionHeaderAction({
  className,
  icon: Icon,
  label,
  onClick,
}: SectionHeaderActionProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          aria-label={label}
          className={cn("pointer-coarse:size-[44px]", className)}
          onClick={onClick}
          size="mobileTouchIcon"
          type="button"
          variant="ghost"
        >
          <Icon aria-hidden="true" className="size-4" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
}
